import React, {useState, useEffect, useContext} from "react";
import {useAPI} from "../../../hooks/useAPI";
import {useSocket} from "../../../hooks/useSocket";
import {General_API} from "../../General/General_API";
import Modal from "../../../components/Modal";
import TablePage from "../../../components/Pages/TablePage/TablePage";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {formatDate} from "../../../utils/utils";
import StatusCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/StautsCell/StatusCell";
import styled from "styled-components";
import NotificationsModalOrganization from "./NotificationsModal.verificationCenter";
import {API_VerificationCenter} from "../../../api/verifcationCenter";
import SocketStore from "../../../stores/socket.store";
import {AuthContext} from "../../../context/AuthContext";

function NotificationsVerificationCenter(props) {
    const {APIRequest} = useAPI();
    const userId = useContext(AuthContext)?.token?.userId
    //Модальное окно

    const [modal, setModal] = useState();
    const [image, setImage] = useState("");

    const addModal = async (id, status, userId) => {
        setModal(id)
    };

    const deleteModal = () => {
        setModal((prev) => {
            const newArr = [...prev];
            newArr.splice(0, 1);
            return newArr;
        });
    };

    const toBegin = () => {
        let a = document.createElement('a')
        a.href = '#first-row'
        a.click()
        window.history.back()

    }
    // ***

    //Страница
    const [filterOptions, setFilterOptions] = useState("");
    const [limit, setLimit] = useState(20);
    const [offset, setOffset] = useState(1);
    const [data, setData] = useState([]);

    const [pagination, setPagination] = useState({
        limit: 20,
        resultsCount: 0,
        offset: 1,
        allPages: 2,
    });

    function offsetHandler(offset) {
        setPagination(value => ({...value, offset: offset}));
        setOffset(offset)
    }

    function limitHandler(limit) {
        setPagination(value => ({...value, limit}));
        setLimit(limit)
    }

    const filterHandler = (e) => {
        setFilterOptions(e);
        offsetHandler(1);
    };

    const changeDataStatus = (id, value) => {
        data.forEach((item) => {
            if (item._id === id)
                setData((prev) => [...prev, {...item, status: value}]);
        });
    };
    //Получение данных
    const getData = async () => {
        await APIRequest(API_VerificationCenter.notifications.getNotifications(userId, pagination.limit, pagination.offset, filterOptions)).then(
            (res) => {
                if (res.status === 200) {
                    setData(res?.body?.data);
                    res?.body?.pagination && setPagination({
                        ...pagination,
                        resultsCount: res.body?.pagination?.resultsCount
                    })
                }
            }
        );
    };

    useEffect(() => {
        getData();
        toBegin()
    }, [pagination.offset, pagination.limit, filterOptions])

    useEffect(() => {
        SocketStore.addListeners(socket => socket.emit("join", "verCenter"))
        SocketStore.addListeners(socket => socket.on("updatePage", _ => getData()))
    }, []);

    //Осталаьное
    const statusColorSwitcher = (status) => {
        if (status === "В ожидании" || status === "Ожидание") return "blue";
        if (status === "Отклонено") return "red";
        if (status === "В работе") return "orange";
        if (status === "Одобрено") return "green";
        if (status === "Занято") return "orange2";
        if (status === "Согласовать") return "orange";
        if (status) return "green";
    };

    const statusSwitcher = (id, status, userId) => {
        if (status !== "Отклонено" && status !== "Занято")
            addModal(id, status, userId)

    };
    // @ts-ignore
    return (
        <>
            {modal && (
                <NotificationsModalOrganization
                    id={modal}
                    setModal={setModal}
                    getData={getData}
                />
            )}


            <TablePage
                pageName={"TablePage"}
                loading={false}
                tableFirstRow={[
                    {title: " ", style: {display: "none"}},
                    {title: "#"},
                    {title: "Действие"},
                    {title: "Дата"},
                    {title: "Статус"},
                ]}
                tableHaveToShow={[
                    {type: "wrapperCell", typeData: {cell: (props) => " "}},
                    {
                        type: "wrapperCell",
                        onClick: (props) => statusSwitcher(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => <LinkCell3 linkTitle={props.all?.ticket_id}/>,
                        },
                    },
                    {
                        type: "wrapperCell",
                        onClick: (props) =>
                            statusSwitcher(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => <LinkCell3 linkTitle={props.all?.type}/>,
                        },
                    },

                    {
                        type: "wrapperCell",
                        onClick: (props) =>
                            statusSwitcher(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => (
                                <LinkCell3 linkTitle={formatDate(props?.all?.created_at)}/>
                            ),
                        },
                    },
                    {
                        type: "wrapperCell",
                        onClick: (props) =>
                            statusSwitcher(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => (
                                <StatusCell
                                    color={statusColorSwitcher(props?.all?.status)}
                                    text={props?.all?.status}
                                />
                            ),
                        },
                    },
                ]}
                tableStorage={data}
                tableTitle={""}
                sortHandler={() => {
                }}
                filterChangeURL={filterHandler}
                showCountChanger={limitHandler}
                setActualPage={offsetHandler}
                breadCrumbsItems={[
                    {title: "Главная"},
                    {title: "Уведомелния", actual: true},
                ]}
                filterFieldsConf={{
                    period: true,
                    date: true,
                }}
                pagination={pagination}
                filterBarButtons={{downloadTemplate: {show: false}}}
                addOrg={{}}
                exportTemplateButtons={{export: false, registry: false}}
            />
        </>
    );
}

const StyledImage = styled.div`
  background-image: url(${(p) => p?.imageLink});
  max-width: 100%;
  max-height: 100%;
  width: 60%;
  height: 60%;
  background-repeat: round;
`;

export default NotificationsVerificationCenter;
